import { render } from "./CorporateFooter.vue?vue&type=template&id=5535793c&scoped=true"
const script = {}

import "./CorporateFooter.vue?vue&type=style&index=0&id=5535793c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5535793c"]])

export default __exports__